enum OfferStatusFilter {
    WaitingAcceptance = 0,
    Accepted = 1,
    WaitingConfirmation = 2,
    Confirmed = 3,
}

export default OfferStatusFilter;
